import {
    ADD_ERROR_MESSAGE,
    ADD_SUCCESS_MESSAGE,
    REMOVE_ERROR_MESSAGE,
    REMOVE_SUCCESS_MESSAGE,
    REMOVE_ALL_MESSAGES,
} from "../actions/messaging";


const initialMessagingState = {
    success: [
        //  {
        //      heading: <message_heading>,  // uniquely identifies message
        //      content: <message_content>,
        //  },
        //  ...
    ],
    error: [
        //  same as for success
    ],
};

export function messages(state = initialMessagingState, action) {
    switch(action.type) {

        case ADD_SUCCESS_MESSAGE:
            return {
                ...state,
                success: [ ...state.success, { heading: action.heading, content: action.content } ]
            };

        case REMOVE_SUCCESS_MESSAGE:
            return {
                ...state,
                success: state.success.filter(item => ( item.heading !== action.heading ))
            };

        case ADD_ERROR_MESSAGE:
            return {
                ...state,
                error: [ ...state.error, { heading: action.heading, content: action.content } ]
            };

        case REMOVE_ERROR_MESSAGE:
            return {
                ...state,
                error: state.error.filter(item => ( item.heading !== action.heading ))
            };

        case REMOVE_ALL_MESSAGES:
            return {
                ...state,
                success: [],
                error: [],
            };

        default:
            return state;
    }
}